'use es6';

import { fromJS } from 'immutable';
import apiClient from 'hub-http/clients/apiClient';
import * as FilterTypes from 'SalesContentIndexUI/data/lib/FilterTypes';
export function fetchOwnersAndTeams(contentType, selectedId, selectedType) {
  return apiClient.post('salescontentsearch/v2/search/owners', {
    data: {
      contentTypes: [contentType],
      selectedOwnerId: selectedType === FilterTypes.USER ? selectedId : null,
      selectedTeamId: selectedType === FilterTypes.TEAM ? selectedId : null
    }
  }).then(response => {
    let ownersAndTeams = fromJS(response);
    if (selectedType === FilterTypes.USER && ownersAndTeams.get('selectedOwner')) {
      ownersAndTeams = ownersAndTeams.set('owners', ownersAndTeams.get('owners').toSet().add(ownersAndTeams.get('selectedOwner')));
    } else if (selectedType === FilterTypes.TEAM && ownersAndTeams.get('selectedTeam')) {
      // Sometimes the selected team can be different enough from the team
      // in the teams array to not properly work as a Set so look for an existing
      // selected teqm id in the teams list
      const selectedTeamFromList = ownersAndTeams.get('teams').find(team => {
        return team.get('id') === ownersAndTeams.get('selectedTeam').get('id');
      });
      if (!selectedTeamFromList) {
        ownersAndTeams = ownersAndTeams.set('teams', ownersAndTeams.get('teams').push(ownersAndTeams.get('selectedTeam')));
      }
    }
    return ownersAndTeams.toJS();
  });
}